import { isSectionsEnabled } from '../sections';

export const isFakeBrowserEnabled = () => isSectionsEnabled();
